// Build-time feature flags baked from VUE_APP_* env vars at compile time.
// Set in .env.<environment> at the repo root per deployment.

export const disableLoggedInPrice =
  process.env.VUE_APP_DISABLE_LOGGED_IN_PRICE === "true";

export const disableRegistrations =
  process.env.VUE_APP_DISABLE_REGISTRATIONS === "true";

export const enablePersonsPerTerm =
  process.env.VUE_APP_ENABLE_PERSONS_PER_TERM === "true";
